import { IGovernmentProjectPagedRequest } from '../../../../model/apm/government-project/request/government-project-paged-request';
import { IGovernmentProjectResponse } from '../../../../model/apm/government-project/response/government-project-response';

export type GovernmentProjectSearchState = {
    parameters: IGovernmentProjectPagedRequest;
    searchTrigger: number;
    drawer: { open: boolean; project?: IGovernmentProjectResponse };
};

export enum ACTION_TYPES {
    updateParameter = 'updateParameter',
    triggerSearch = 'triggerSearch',
    openDrawer = 'openDrawer',
    closeDrawer = 'closeDrawer',
}

export const GovernmentProjectSearchReducer = (state: GovernmentProjectSearchState, action: any): GovernmentProjectSearchState => {
    const { type, payload } = action;
    switch (type) {
        case ACTION_TYPES.updateParameter:
            return { ...state, parameters: { ...state.parameters, ...payload } };
        case ACTION_TYPES.triggerSearch:
            return { ...state, searchTrigger: state.searchTrigger + 1 };
        case ACTION_TYPES.openDrawer:
            return { ...state, drawer: { open: true, project: payload } };
        case ACTION_TYPES.closeDrawer:
            return { ...state, drawer: { open: false } };
        default:
            throw new Error(`Unhandled action type: ${type}`);
    }
};
